import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { storeToRefs } from 'pinia'
import { message } from 'ant-design-vue'
import useUserStore from '@/stores/userInfo.js'
import whiteRoutes from '@/router/whiteRoutes'
import checkPermissionMenu from '@/utils/checkPermissionMenu'
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css' // 引入 nprogress 样式

// 隐藏右上角的loading动画
NProgress.configure({ showSpinner: false })

// 导入各路由模块
const files = import.meta.globEager('./module/*.{js,ts}')
let routeModules = []
Object.entries(files).forEach((_routes) => {
  const childModule = _routes[1].default
  routeModules = routeModules.concat(childModule)
})

export const asyncRoutes = [...routeModules]
const router = createRouter({
  history: createWebHistory('/'),
  // history: createWebHashHistory('/'),
  routes: [...asyncRoutes, ...whiteRoutes]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  document.title = to?.meta.alias || '新财董'

  // console.log(storeToRefs(useUserStore().loginOut()), '555555555555555555')

  // const userStore = useUserStore()
  // userStore.loginOut()
  // console.log(userStore)
  const { qrcodeid, peerid, userInfo, menus } = storeToRefs(useUserStore())

  const toPath = to.path
  const isWhite = whiteRoutes.map((item) => item.path).includes(toPath)
  // 白名单路由
  if (isWhite) {
    next()
  } else {
    if (!qrcodeid.value) {
      message.error('登录已过期，请重新登录！')
      router.replace({ path: '/' })
    } else if (!to.matched || !to.matched.length) {
      // console.log(to.path, '无法跳转路由')
      // 无法匹配的路由跳转到404页面
      next('/exception/404')
    } else if (to.meta.exemption) {
      if (userInfo.value.sessionid && peerid) {
        next()
      } else {
        router.replace({ path: '/' })
      }
    } else if (!checkPermissionMenu(to.matched[to.matched.length - 1].path, menus.value)) {
      // 如果没有权限则跳转403页面
      next('/')
    } else {
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
